.grid {
    display: grid;
    grid-template-rows: repeat(4, auto);
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-auto-flow: column;
    width: 100%;
    border-top: var(--border-hairline);
}

.cell {
    min-width: 0;
    border-right: var(--border-hairline);
    border-bottom: var(--border-hairline);
}

/* Last column: no right border */
.cell:nth-child(n + 13) {
    border-right: none;
}

/* Last row of month cells (every 3rd in column order): no bottom border */
.cell:nth-child(4n + 3) {
    border-bottom: none;
}

.footer-cell {
    grid-row: 4;
    min-width: 0;
    border-right: var(--border-hairline);
    border-top: var(--border-hairline);
    border-bottom: var(--border-hairline);
    background-color: var(--off-white);
}

.footer-cell:last-of-type {
    border-right: none;
}
